import { IconContext } from 'react-icons'
import { FaShareNodes } from 'react-icons/fa6'
import React from 'react'
import axios from 'axios'
import { axiosConfig } from '../plugins/utils/ascUtils'

interface Props {
    config: any
    sender_id: string
}

export const ShareButton: React.FC<Props> = ({ config, sender_id }) => {
    const { header_bg_color, header_button_text_color } = config

    const url = window.location.href
    const title = 'AccessAva'
    const text =
        'Have you heard about AccessAva?\n' +
        '\n' +
        'If you are struggling to understand your rights to social care, AccessAva can help you find the right information quickly and easily.\n'

    const shareDetails = {
        url,
        title,
        text,
    }

    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share(shareDetails).then(async () => {
                    console.log('Sharing succeeded')
                    const jsonBodyData = {
                        message: `buttonclick | share`,
                        payload: '',
                        sender: sender_id,
                        msg_type: 'log_click',
                    }
                    const response = await axios.post(`https://asc-saas-action-server-prod.azurewebsites.net/webhook`, jsonBodyData, axiosConfig)
                })
            } catch (error) {
                console.log(`Sharing failed: ${error}`)
            }
        } else {
            // fallback code
            console.log('Web share is currently not supported on this browser. Please provide a callback')
        }
    }
    return (
        <div
            className='buttonContainer'
            style={{ marginLeft: '5px' }}
        >
            <button
                style={{ color: header_button_text_color, backgroundColor: header_bg_color }}
                onClick={() => handleShare()}
            >
                <IconContext.Provider value={{ size: '1.2em' }}>
                    <div>
                        <FaShareNodes />
                    </div>
                </IconContext.Provider>
            </button>
        </div>
    )
}
